import JSXComponent from "../../../dist/jsx-render/JSXComponent";
import dom from "../../../dist/jsx-render/dom";
import { ISearchResult } from "../../Model/Search/ISearchResult";
import { app } from "../../Frame/App";
import { PagePopup, PopupCloseType } from "../../Controls/PagePopup";

export type SearchPreviewProps = {
    /** Search inout by the user */
    searchTerm: string;

    /** Textbox */
    parentInput: HTMLElement;

    /** Which side of the parentInput to align the preview box on. */
    align?: "left" | "right";
}

export class SearchPreview extends JSXComponent {
    props: SearchPreviewProps;
    constructor(props: SearchPreviewProps) { super(props) }

    element: HTMLDivElement;
    getElement = () => {
        let element = <div className="search-preview">
            <div className="search-object-type">
                <div className="form-group">
                    <label className="form-label">{Resources.Begriffe.massnahmen}</label>
                    <div className="search-results-measure">

                    </div>
                </div>

                <div className="form-group">
                    <label className="form-label">{Resources.Begriffe.dokumente}</label>
                    <div className="search-results-documents">

                    </div>
                </div>
            </div>
        </div>;

        return element;
    }

    getData = () => {
        $.getJSON(app.resolveUrl(`~/api/search/search/${encodeURIComponent(this.props.searchTerm)}/3`), (data: ISearchResult[]) => {
            let dataMeasure = data.filter(r => r.type == "measure" || r.type == "measureContent");
            let dataDocument = data.filter(r => r.type == "document");

            let resultsMeasureElement = this.element.querySelector(".search-results-measure") as HTMLDivElement;
            let resultsDocumentsElement = this.element.querySelector(".search-results-documents") as HTMLDivElement;

            if (resultsMeasureElement) {
                resultsMeasureElement.appendChild(
                    <ul className="list-measures">
                        {dataMeasure.map((value: ISearchResult, index: number) => {
                            if (index < 3) {
                                let listElement = <li className="measure-result">
                                    <span>
                                        <a className="measure-link" href={value.redirectOnClick ? app.resolveUrl(value.link) : "#"} data-id={value.id}>
                                            {`${value.template && value.template.length > 0 ? value.template : value.sourceObject}${app.searchShowId ? " " + value.id : ""}: ${value.title ?? ""}${(value.sourceField ? ": " + value.sourceField : "")}`}
                                        </a>
                                    </span>
                                </li>

                                if (!value.redirectOnClick) {
                                    let link = listElement.querySelector(".measure-link") as HTMLAnchorElement;
                                    link.addEventListener("click", () => {
                                        const popup = new PagePopup({
                                            url: value.link,
                                            fullScreen: true,
                                        });
                                    });
                                }

                                return listElement;
                            }
                        })}
                    </ul>
                );
            }

            if (resultsDocumentsElement) {
                resultsDocumentsElement.appendChild(
                    <ul className="list-measures">
                        {dataDocument.map((value: ISearchResult, index: number) => {
                            if (index < 3) {
                                let listElement = <li className="document-result">
                                    <span>
                                        <a className="measure-link" href={value.redirectOnClick ? app.resolveUrl(value.link) : "#"}>
                                            {`${Resources.Common.measure} ${value.title} ${value.sourceObject} ${value.id}: ${value.value ?? ""}`}
                                        </a>
                                    </span>
                                </li>

                                if (!value.redirectOnClick) {
                                    let link = listElement.querySelector(".measure-link") as HTMLAnchorElement;
                                    link.addEventListener("click", () => {
                                        const popup = new PagePopup({
                                            url: value.link,
                                            fullScreen: true,
                                        });
                                    });
                                }

                                return listElement;
                            }
                        })}
                    </ul>
                );
            }
        });
    }

    public render() {
        this.element = this.getElement();

        this.getData();

        // calculate position
        let rect = this.props.parentInput.getBoundingClientRect();

        if (!this.props.align || this.props.align == "right") {
            this.element.style.right = `${window.innerWidth - (rect.x + rect.width)}px`;
            this.element.style.top = `${rect.bottom}px`;
        } else {
            // this.props.align == "left"
            this.element.style.left = `${rect.left}px`;
            this.element.style.top = `${rect.bottom}px`;
        }

        return this.element;
    }
}